// Based on different environments, we can set different configurations
// dev: development environment
// qa: QA environment
// prod: production environment
let configuration: {
    APPLICATION_ENDPOINT: string;
    API_ENDPOINT: string;
    REWARD_API_ENDPOINT: string;
    LOGIN_API_ENDPOINT: string;
    LOGIN_CLIENT_ID: string;
    LOGIN_CLIENT_ID_NEW: string;
    ssoCallbackUrl: string;
    WECHAT_LOGIN_API_ENDPOINT: string;
    ENVIRONMENT: string;
    APP_ID: string;
    WECHAT_QR_APP_ID: string;
    REGISTER_API_ENDPOINT: string;
    NEW_REGISTER_API_ENDPOINT: string;
    CHANGE_PASSWORD: string;
    CID_LOGIN_CN: string;
    CID_REGISTER_CN: string;
    AASrc: string;
    URL_GLOBAL_ORDERHSITORY: string;
} = {
    // use dev configuration as default configuration 
    URL_GLOBAL_ORDERHSITORY: "https://dev1.thermofisher.cn/store/orders/history",
    APPLICATION_ENDPOINT: "https://dev1-mapac.thermofisher.cn",
    API_ENDPOINT: "https://dev1-api-mapac.thermofisher.cn/m-api",
    REWARD_API_ENDPOINT: "https://dev1-api-mapac.thermofisher.cn/reward-api",
    LOGIN_API_ENDPOINT:
      "https://qa4.thermofisher.cn/api-gateway/identity-authorization/identity/oidc/op/authorize",
    LOGIN_CLIENT_ID: "m4ygnuG_7pQCufXokfbWIxWp",
    LOGIN_CLIENT_ID_NEW: "m4ygnuG_7pQCufXokfbWIxWp",
    ssoCallbackUrl: "https://dev1-mapac.thermofisher.cn/sso/callback",
    WECHAT_LOGIN_API_ENDPOINT:
      "https://qa4.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/openId",
    ENVIRONMENT: "dev",
    APP_ID: "wxa5dd6ee758e547bd",
    WECHAT_QR_APP_ID: "wxee8c247c4994a081",
    REGISTER_API_ENDPOINT: "https://qa4.thermofisher.cn",
    NEW_REGISTER_API_ENDPOINT:
      "https://qa4.thermofisher.cn/identity/api/cip/v1/registration/auth",
    CHANGE_PASSWORD: "https://qa4.thermofisher.cn/identity/change-password/",
    CID_LOGIN_CN: "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_login_JR247MP",
    CID_REGISTER_CN:
      "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_registration_6XP9YYI",
    AASrc: "https://assets.adobedtm.com/7e08552ade3f/35843b661d07/launch-4910de16ef63-development.min.js"

};
let activityPrefix = 'https://dev1-mapac.thermofisher.cn/marketing-api'
let mobilityPrefix = 'https://dev1-api-mapac.thermofisher.cn/m-api';
let adminReferrerPrefix = 'https://dev1-admin-apac.clouddev.thermofisher.net.cn/';
let stockCenterPrefix = 'https://qa.xianhuo.thermofisher.cn';
console.log(process.env.REACT_APP_APP_ENV);
if (process.env.REACT_APP_APP_ENV === "dev") {
  // set the configuration use above content and remove prefix NEXT_PUBLIC_ for each key
  activityPrefix = 'https://dev1-api-mapac.thermofisher.cn/marketing-api'
  mobilityPrefix = 'https://dev1-api-mapac.thermofisher.cn/m-api';
  adminReferrerPrefix = 'https://dev1-admin-apac.clouddev.thermofisher.net.cn/';
  configuration = {
    URL_GLOBAL_ORDERHSITORY: "https://dev1.thermofisher.cn/store/orders/history",
    APPLICATION_ENDPOINT: "https://dev1-mapac.thermofisher.cn",
    API_ENDPOINT: "https://dev1-api-mapac.thermofisher.cn/m-api",
    REWARD_API_ENDPOINT: "https://dev1-api-mapac.thermofisher.cn/reward-api",
    LOGIN_API_ENDPOINT:
      "https://qa4.thermofisher.cn/api-gateway/identity-authorization/identity/oidc/op/authorize",
    LOGIN_CLIENT_ID: "m4ygnuG_7pQCufXokfbWIxWp",
    LOGIN_CLIENT_ID_NEW: "m4ygnuG_7pQCufXokfbWIxWp",
    ssoCallbackUrl: "https://dev1-mapac.thermofisher.cn/sso/callback",
    WECHAT_LOGIN_API_ENDPOINT:
      "https://qa4.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/openId",
    ENVIRONMENT: "dev",
    APP_ID: "wxa5dd6ee758e547bd",
    WECHAT_QR_APP_ID: "wxee8c247c4994a081",
    REGISTER_API_ENDPOINT: "https://qa4.thermofisher.cn",
    NEW_REGISTER_API_ENDPOINT:
      "https://qa4.thermofisher.cn/identity/api/cip/v1/registration/auth",
    CHANGE_PASSWORD: "https://qa1.thermofisher.cn/identity/change-password/",
    CID_LOGIN_CN: "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_login_JR247MP",
    CID_REGISTER_CN:
      "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_registration_6XP9YYI",
    AASrc: "https://assets.adobedtm.com/7e08552ade3f/35843b661d07/launch-4910de16ef63-development.min.js"
  };
}
if (process.env.REACT_APP_APP_ENV === "qa") {
  console.log('qa', process.env.REACT_APP_APP_ENV)
  activityPrefix = 'https://qa1-api-mapac.thermofisher.cn/marketing-api'
  mobilityPrefix = 'https://qa1-api-mapac.thermofisher.cn/m-api';
  adminReferrerPrefix = 'https://qa1-admin-apac.cloudqa.thermofisher.net.cn/';
  stockCenterPrefix = 'https://qa.xianhuo.thermofisher.cn';
  configuration = {
    URL_GLOBAL_ORDERHSITORY: "https://qa1.thermofisher.cn/store/orders/history",
    APPLICATION_ENDPOINT: "https://qa1-mapac.thermofisher.cn",
    API_ENDPOINT: "https://qa1-api-mapac.thermofisher.cn/m-api",
    REWARD_API_ENDPOINT: "https://qa1-api-mapac.thermofisher.cn/reward-api",
    LOGIN_API_ENDPOINT:
      "https://qa1.thermofisher.cn/api-gateway/identity-authorization/identity/oidc/op/authorize",
    LOGIN_CLIENT_ID: "mdRhSlQ3Dj5u4enPNI9UBvhh",
    LOGIN_CLIENT_ID_NEW: "mdRhSlQ3Dj5u4enPNI9UBvhh",
    ssoCallbackUrl: "https://qa1-mapac.thermofisher.cn/sso/callback",
    WECHAT_LOGIN_API_ENDPOINT:
      "https://qa1.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/openId",
    ENVIRONMENT: "qa",
    APP_ID: "wxa5dd6ee758e547bd",
    WECHAT_QR_APP_ID: "wxee8c247c4994a081",
    REGISTER_API_ENDPOINT: "https://qa1.thermofisher.cn",
    NEW_REGISTER_API_ENDPOINT:
      "https://qa1.thermofisher.cn/identity/api/cip/v1/registration/auth",
    CHANGE_PASSWORD: "https://qa1.thermofisher.cn/identity/change-password/",
    CID_LOGIN_CN: "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_login_JR247MP",
    CID_REGISTER_CN:
      "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_qa_registration_6XP9YYI",
    AASrc: "https://assets.adobedtm.com/7e08552ade3f/35843b661d07/launch-b5358dbcde6b-staging.min.js"
  };
}
if (process.env.REACT_APP_APP_ENV === "prod") {
  // set the configuration use above content and remove prefix NEXT_PUBLIC_ for each key
  activityPrefix = 'https://api-mapac.thermofisher.cn/marketing-api'
  mobilityPrefix = 'https://api-mapac.thermofisher.cn/m-api';
  adminReferrerPrefix = 'https://admin-apac.cloudprod.thermofisher.net.cn/';
  stockCenterPrefix = 'https://xianhuo.thermofisher.cn';
  configuration = {
    URL_GLOBAL_ORDERHSITORY: "https://www.thermofisher.cn/store/orders/history",
    APPLICATION_ENDPOINT: "https://mapac.thermofisher.cn",
    API_ENDPOINT: "https://api-mapac.thermofisher.cn/m-api",
    REWARD_API_ENDPOINT: "https://api-mapac.thermofisher.cn/reward-api",
    LOGIN_API_ENDPOINT:
      "https://www.thermofisher.cn/api-gateway/identity-authorization/identity/oidc/op/authorize",
    LOGIN_CLIENT_ID: "S1OKRTqJGq1czcKsbkwfbQtD",
    LOGIN_CLIENT_ID_NEW: "6P_WrHaEb3QF-XFD1a4-2bA0",
    ssoCallbackUrl: "https://mapac.thermofisher.cn/sso/callback",
    WECHAT_LOGIN_API_ENDPOINT:
      "https://www.thermofisher.cn/api-gateway/identity-wechat/identity/wechat/openId",
    ENVIRONMENT: "prod",
    APP_ID: "wx923804b1d49f51fb",
    WECHAT_QR_APP_ID: "wx5bd769c67ffcb252",
    REGISTER_API_ENDPOINT: "https://www.thermofisher.cn",
    NEW_REGISTER_API_ENDPOINT:
      "https://www.thermofisher.cn/identity/api/cip/v1/registration/auth",
    CHANGE_PASSWORD: "https://www.thermofisher.cn/identity/change-password/",
    CID_LOGIN_CN: "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_prod_login_2VOT7DX",
    CID_REGISTER_CN:
      "ebz_bus_sbu_r04_cn_0db_thermo_wn_str_pwa_prod_registration_V45STMN",
    AASrc: "https://assets.adobedtm.com/7e08552ade3f/35843b661d07/launch-da6e32bc537b.min.js"
  };
}

export const orderStatusMap = {
  PENDING_REVIEW_NOTE: '若订单审核超过48小时，建议您点击需要帮助',
  'Waiting for Delivery': '等待交货',
  SUBMITTED: '已提交',
  ORDER_SUBMITTED: '订单已提交',
  PENDING_REVIEW: '待审核',
  TO_BE_CONFIRMED: '待确认',
  IN_PROGRESS: '处理中',
  COMPLETED: '已完成',
  PENDING_ADDRESS_VALIDATION: '等待确认地址',
  CANCELLED: '已取消',
  PENDING_APPROVAL: '待批准',
  SHIPPED: '已发货',
  PENDING: '等待中'
}

// dev env
const labelMapDev = {
  Presales: '99cf349a17a64960a0cec0cb9cb61c97',
  'Digital CSR': '1f12a40dd0a84e369f4ca91ce3654d62'
}

// prod env
const labelMapProd = {
  Presales: '154b6fdf225144aaa086b7668456b335',
  'Digital CSR': '73623336d4ab4f2097bb488d23a6ef4b'
}

export const currentAdminReferrerPrefix = adminReferrerPrefix;
export const stockCenterSelectCustomerUrl = `${stockCenterPrefix}/purchase/selectCustomer`;
export const stockCenterAdminLoginUrl = `${stockCenterPrefix}/adminLogin`;
export const stockCenterUserCenterUrl = `${stockCenterPrefix}/userCenter`;
export const stockCenterMyOrdersUrl = `${stockCenterPrefix}/myOrderList/unreceived`;
export const supplyCenterLtoHistoryListUrl = `${stockCenterPrefix}/purchase/ltoHistoryList`;
export const mobilityPendingLtoUrl = `${configuration.APPLICATION_ENDPOINT}/my-orders/PendingLTO/`;

export const openTfsRuleUrl =
    `${stockCenterPrefix}/att/Thermo_Fisher_China_Booking_Policy_V1.pdf`;
export const openTfsChangeRuleUrl =
    `${stockCenterPrefix}/att/Thermo_Fisher_China_Sales_Return_Policy_V2.pdf`;

export const labelMap = process.env.REACT_APP_APP_ENV !== 'prod' ? labelMapDev : labelMapProd

export const sobotSysnum = process.env.REACT_APP_APP_ENV !== 'prod' ? '1f1eca5d32b6435498dbb2c95591165a' : 'bae581666bdb4580ab93d94c6e0f9401'
export const sobotDomainPC = process.env.REACT_APP_APP_ENV !== 'prod' ? 'mobility-test' : 'thermofisher'
export const sobotDomainMob = process.env.REACT_APP_APP_ENV !== 'prod' ? 'mobility-test' : 'thermofisher'
export const sobotChannelId = process.env.REACT_APP_APP_ENV !== 'prod' ? '2' : '2'
export const isTestEnv = process.env.REACT_APP_APP_ENV !== 'prod'
export const sobotUrlTestPC = 'https://thermofisher.sobot.com/chat/frame/v6/entrance.js?sysnum=86f8289ae8794c97820bf11eb1632414'

export const wechatLoginAuthUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
export const wechatLoginQRUrl = 'https://open.weixin.qq.com/connect/qrconnect'
export const activityDetailUrl = `${activityPrefix}/activity/details`
export const marketingRichTextImageUrl = `${activityPrefix}/rich-text/image`
export const activityCategoryUrl = `${activityPrefix}/activity-product/category/list`
export const activityProductsUrl = `${activityPrefix}/activity-product/search`
export const activityAddOnPurchaseListUrl = `${activityPrefix}/activity-product/add-on-purchase/list`
export const activityBundleListUrl = `${activityPrefix}/activity-product/bundle/list`
export const customerUrl = `${activityPrefix}/customer/details`
export const customerActivityScopeUrl = `${activityPrefix}/customer/activity_scope`
export const ssoAuthorizeUrl = `${activityPrefix}/sso/authorize`
export const cartUrl = `${activityPrefix}/activity/cart/list`
export const cartAddUrl = `${activityPrefix}/activity/cart/add`
export const cartItemQtyUpdateUrl = `${activityPrefix}/activity/cart/quantity`
export const cartItemDeleteUrl = `${activityPrefix}/activity/cart/delete`
export const orderConfirmUrl = `${activityPrefix}/order/preview`
export const submitOrderUrl = `${activityPrefix}/order/submit`
export const productCRDRangeUrl = `${activityPrefix}/product/crd-range`
export const cartCountUrl = `${activityPrefix}/activity/cart/count`
export const operationLogUrl = `${activityPrefix}/operationLog/insert`
export const tieredRuleUrl = `${activityPrefix}/activity/cart/tiered-rule`
export const enableOrderPreviewCRD = true
export default configuration;
export const activityStatusMap:{
  "activity_expired": string;
  "activity_not_published": string;
  "activity_login_required": string;
  "activity_no_permission": string;
  [key: string]: string;
} = {
  "activity_expired": '本次活动已结束，您可点击“促销商城”查看更多活动',
  "activity_not_published": '活动暂未开始，请您耐心等待',
  "activity_login_required": '请登录以参加活动',
  "activity_no_permission": '抱歉，您暂无权限参与本次活动，您可点击“促销商城”查看更多活动',
}
export const activityQuickAddCartUrl = `${activityPrefix}/activity/cart/quick-add`;
export const shareLinkUrl = `${activityPrefix}/share`;
export const addNewAddressaUrl = `${mobilityPrefix}/address/addNew`;
export const liteUserNewAddressUrl = `${mobilityPrefix}/address/full/registration`;

export const AMOUNT_EXCEEDS_LIMIT = 60000;

export const SESSION_STORAGE_KEY_MAP = {
  AUTH_TOKEN: "Tmcustom",
}

export const USER_TYPE = {
  EMPLOYEE: "employee",
  CUSTOMER: "customer",
} as const

export const DUMMY_EMAIL_DOMAIN = "@dummy.com";

export type UserType = (typeof USER_TYPE)[keyof typeof USER_TYPE];

export const ORDER_CHANNEL = {
  ONLINE: "Online",
  OFFLINE: "Offline",
} as const

export type OrderChannel = (typeof ORDER_CHANNEL)[keyof typeof ORDER_CHANNEL];

export const NOTIFICATION_METHOD = {
  MAIL: "mail",
  SMS: "sms",
} as const;

export type NotificationMethodType =
  (typeof NOTIFICATION_METHOD)[keyof typeof NOTIFICATION_METHOD];

export const ACTIVITY_NO_PERMISSION_STATUS_LABEL = "抱歉，您暂无权限参与本次活动";
export const ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL =
  "抱歉，当前账号及收货地址暂无法参与活动";
export const ACTIVITY_NO_PERMISSION_STATUS_VALUE = "activity_no_permission";
export const ACTIVITY_PERMISSION_DATA_TYPE = {
  LOGIN: "Login",
  ST: "ST",
} as const;

export const getActivityNoPermissionStatusLabel = (
  customerDataType?: string
) => {
  return ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL;
};
